module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top-menu"
    }
  }, [_c('header', [_c('div', {
    attrs: {
      "id": "hamburger"
    },
    on: {
      "click": function($event) {
        return _vm.display_menu()
      }
    }
  }, [_vm._v("Menu\n      "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    class: {
      'current-route': this.$route.name == 'HomePage'
    },
    attrs: {
      "id": "main-logo"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'HomePage'
      }
    }
  }, [_c('v-img', {
    attrs: {
      "id": "menu-logo",
      "src": "static/Signature/signature-1.png",
      "height": "30",
      "width": "50"
    }
  })], 1)], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "hidden-homepage-link"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'HomePage'
      }
    }
  }, [_vm._v("\n          ACCUEIL\n        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'current-route': this.$route.name == 'CabinetPage'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'CabinetPage'
      }
    }
  }, [_vm._v("\n          CABINET\n        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'current-route': this.$route.name == 'EngagementPage'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'EngagementPage'
      }
    }
  }, [_vm._v("\n          ENGAGEMENTS\n        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'current-route': this.$route.name == 'ExpertisePage'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ExpertisePage'
      }
    }
  }, [_vm._v("\n          EXPERTISE\n        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'current-route': this.$route.name == 'TreatmentsPage'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TreatmentsPage'
      }
    }
  }, [_vm._v("\n          TRAITEMENTS\n        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'current-route': this.$route.name == 'FAQPage'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'FAQPage'
      }
    }
  }, [_vm._v("\n          FAQ\n        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'current-route': this.$route.name == 'AccessPage'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'AccessPage'
      }
    }
  }, [_vm._v("\n          ACCES\n        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'current-route': this.$route.name == 'ContactPage'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ContactPage'
      }
    }
  }, [_vm._v("\n          CONTACT\n        ")])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-83d9684a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83d9684a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/global/pageHeader/pageHeader.component.html
// module id = 271
// module chunks = 1